package br.com.texeratx.boardgametimeapp.core.active_match

/**
 * "Rascunho" de partida finalizada, pronto para salvar.
 * Por enquanto é só em memória (depois pluga em repository/API).
 */
data class MatchDraft(
    val gameId: Long,
    val gameName: String,
    val dateIso: String,
    val durationMinutes: Int,
    val expansionIds: List<Long>,
    val expansionNames: List<String>,
    val scores: List<PlayerScoreDraft>,
    val observation: String? = null,

    val gameImageUrl: String? = null,
    val playerImageUrls: List<String?> = emptyList()
)

